import angular from "angular";

angular.module('ui-sentinel.shipments.shipmentsList', [
    'api-sentinel', 'api-common'
]);
